import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const OpportunityMeetingInput = () => {
  const { meetingId = '' } = useParams();
  const decodedId = meetingId ? atob(meetingId) : meetingId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'opportunityMeeting';

  useEffect(() => {
    if (meetingId) { setIsEditing(true); fetchDetails(); }
  }, [meetingId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['opportunityMeeting'] + id + '/', { headers });
      const d = response.data?.data ?? response.data;
      setFormData({
        ...d,
        opportunity: d.opportunity?.id ?? d.opportunity,
        attendees: Array.isArray(d.attendees) ? d.attendees.map(a => a?.id ?? a) : d.attendees,
      });
    } catch (error) { console.error('Error fetching Opportunity Meeting details:', error); }
  };

  const fields = [
    {
      name: 'opportunity', label: 'Opportunity', type: 'async-select',
      endpoint: API_ROUTES.opportunity,
      getOptionLabel: (o) => o.opportunity_name,
    },
    { name: 'title', label: 'Meeting Title', type: 'text' },
    { name: 'meeting_date', label: 'Meeting Date & Time', type: 'datetime-local', dateConstraint: 'future' },
    { name: 'meeting_time', label: 'Meeting Time', type: 'time' },
    { name: 'duration_minutes', label: 'Duration (minutes)', type: 'number' },
    { name: 'location', label: 'Location', type: 'text' },
    { name: 'description', label: 'Agenda / Description', type: 'textarea' },
    {
      name: 'attendees', label: 'Attendees', type: 'async-multiselect',
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
    },
    { name: 'is_online', label: 'Online Meeting', type: 'checkbox' },
    {
      name: 'type_of_online_meeting', label: 'Online Platform', type: 'select',
      options: [
        { value: '', label: '— N/A —' },
        { value: 'Zoom', label: 'Zoom' },
        { value: 'Google Meet', label: 'Google Meet' },
        { value: 'Microsoft Teams', label: 'Microsoft Teams' },
        { value: 'Skype', label: 'Skype' },
        { value: 'Other', label: 'Other' },
      ],
    },
    { name: 'online_meeting_link', label: 'Meeting Link', type: 'text' },
    {
      name: 'meeting_status', label: 'Status', type: 'select',
      options: [
        { value: 'scheduled', label: 'Scheduled' },
        { value: 'in_progress', label: 'In Progress' },
        { value: 'completed', label: 'Completed' },
        { value: 'cancelled', label: 'Cancelled' },
        { value: 'rescheduled', label: 'Rescheduled' },
      ],
    },
    { name: 'outcome', label: 'Outcome / Minutes', type: 'textarea' },
    { name: 'follow_up_required', label: 'Follow-up Required', type: 'checkbox' },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Opportunity Meeting' : 'Create Opportunity Meeting'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default OpportunityMeetingInput;
